import "../../../resources/less/Admin/Licences/AddLicenceFamily.less";
import NanomonxForm from "../../components/Forms/NanomonxForm";
import CSwitchToTeacher from "../../Family/CSwitchToTeacher";

class AddLicenceFamily {
  private familyComparisonSection: JQuery<HTMLElement>;
  private familyFormSection: JQuery<HTMLElement>;
  private packageSelect: JQuery<HTMLInputElement>;

  constructor() {
    this.familyComparisonSection = $(".js-family-packages");
    this.familyFormSection = $(".js-family-form-section");
    this.packageSelect = $(".js-package-select");

    new CSwitchToTeacher();
    if ($(".purchase_email_form").length > 0) {
      new NanomonxForm({
        elementName: "purchase_email_form",
        submitClass: ".form-validate-email-submit",
        withValidation: false,
      });
    }

    $(".js-sel-package, .js-back-family-packages").on("click", () => {
      this.familyComparisonSection.toggleClass("hide");
      this.familyFormSection.toggleClass("hide");
    });

    $(".js-sel-monthly-package").on("click", () => {
      this.packageSelect.val("FAMILY_RECURRING");
      $(".js-is-annual-package").addClass("hide");
      $(".js-is-monthly-package").removeClass("hide");

      $(".js-buy-monthly-family-package").removeClass("hide");
      $(".js-buy-yearly-family-package").addClass("hide");

      // Show appropriate warning for monthly packages
      $(".js-monthly-warning").removeClass("hide");
      $(".js-yearly-warning").addClass("hide");
    });

    $(".js-sel-yearly-package").on("click", () => {
      this.packageSelect.val("FAMILY_YEARLY");
      $(".js-is-monthly-package").addClass("hide");
      $(".js-is-annual-package").removeClass("hide");

      $(".js-buy-monthly-family-package").addClass("hide");
      $(".js-buy-yearly-family-package").removeClass("hide");

      // Show appropriate warning for yearly packages
      $(".js-monthly-warning").addClass("hide");
      $(".js-yearly-warning").removeClass("hide");
    });
  }
}

$(window).on("load", () => {
  new AddLicenceFamily();
});
